AccountsCtrl.$inject = ['$scope', '$translate', '$state', '$stateParams', '$filter', 'Bills', 'Notification', '$rootScope','PortalApi','$timeout','Localization'];
function AccountsCtrl ($scope, $translate, $state, $stateParams, $filter, Bills, Notification, $rootScope, PortalApi, $timeout,Localization) {
    var dateNow = new Date();
    var MAX_PERIOD_IN_MONTH = 3;

    $scope.innerState = '';
    $scope.preLoader = false;

    $scope.bills = [];
    $scope.subscribers = [];
    $scope.history = [];

    $scope.periodBegin = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1);
    $scope.periodEnd = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
    $scope.beginDatePickerOpen = false;
    $scope.endDatePickerOpen = false;
    $scope.dateFromOptions = {
        formatDayTitle: 'MMMM yyyy',
        showWeeks: false,
        minDate: new Date(dateNow.getMonth() - 2),
        maxDate: dateNow
    };

    $scope.changeInnerState = function (state) {
        $scope.innerState = state;
        $scope.preLoader = true;
    };

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.doChanges = function (obj) {
        $scope.id = obj.subscribeId;

    };

    $scope.close = function(){
        $scope.id = null;
    };

    $scope.changeSubscriptionName = function(){

    };

    $scope.sendNewName = function(obj, newName){

        PortalApi.editSubscriptionName({"subscribeId": obj.subscribeId,"subscriptionName" : newName}).then(function (response) {
            $scope.newSubscribeName = newName;
            $scope.subscribers.map(function (service) {
                if(service.subscribeId == obj.subscribeId){
                    service.name = newName;
                }
            });
            Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.SUBSCRIPTION_SAVE', 5, true);

        },function (response) {
            Localization.notifyTemplate('error', 'ERRORS.SUBSCRIPTION_SAVE', 5, true);
        });

        $scope.id = null;
    };

    $scope.openDatePickerPopup = function (type) {
        var name = type + 'DatePickerOpen';
        $scope[name] = !$scope[name];
    };

    $scope.getBills = function (offset, force) {
        var req = {
            dateFrom: $filter('date')($scope.periodBegin, 'yyyy-MM-dd'),
            dateTo: $filter('date')($scope.periodEnd, 'yyyy-MM-dd')
        };

        $scope.changeInnerState('bills');

        if (+$scope.periodEnd - +$scope.periodBegin > MAX_PERIOD_IN_MONTH * 31 * 24 * 60 * 60 * 1000) {
            $translate('ERRORS.INCORRECT_PERIOD', {'max_period_month': MAX_PERIOD_IN_MONTH}).then(function(text) {
                Notification.error({
                    message: text,
                    delay: 5000
                });

                $scope.preLoader = false;
            });
        } else {
            Bills.getBills(req, true).then(
                function(response) {
                    var newBill;

                    $scope.bills = response;

                    if ($stateParams.newBillId &&
                        Array.isArray($scope.bills) &&
                        $scope.bills.length
                    ) {
                        $scope.bills.forEach(function (bill) {
                            if (bill.bill_id == $stateParams.newBillId) {
                                newBill = bill;
                            }
                        });

                        if (newBill) {
                            return $translate('DICTIONARY.NEW_BILL_SERVICE').then(function(transform1) {
                                return $translate('DICTIONARY.ON_SUM').then(function(transform2) {
                                    return $translate('DICTIONARY.грн').then(function(transform3) {
                                        return Notification.success({
                                            message: transform1 + ' ' + newBill.name + ' ' + transform2 + ' ' + transform3,
                                            delay: 7*1000
                                        });
                                    });
                                });
                            });
                        }

                        $stateParams.newBillId = null;
                    }
                }, function () {
                    Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
                }
            ).finally(function () {
                $scope.preLoader = false;
            });
        }
    };

    $scope.getSubscribers = function () {
        $scope.changeInnerState('subscribers');

        Bills.getSubscribers({}, true).then(
            function(response) {
                $scope.subscribers = response;
            }, function () {
                Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
            }
        ).finally(function () {
            $scope.preLoader = false;
        });
    };

    $scope.changeSubscribeStatus = function (subscribeId, status) {
        $scope.changeInnerState('subscribers');

        var data = {
            subscribeId: subscribeId,
            status: status
        };

        Bills.changeSubscribeStatus(data).then(
            function(response) {
                if (response.status != 'ok') {
                    Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
                } else {
                    $scope.getSubscribers();
                }
            }, function () {
                Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
            }
        ).finally(function () {
            $scope.preLoader = false;
        });
    };

    $scope.subscribe = function () {

        Localization.notifyTemplate('warning', 'NOTIFICATION.WARNING.CHOOSE_SERVICE', 10, true);

        $scope.preLoader = true;

        $state.go('pages.services', {
            subscribe: true
        });
    };

    $scope.pay = function (bill) {
        var pay = false;
        $scope.preLoader = true;

        if (bill.fields && Object.keys(bill.fields).length) {
            pay = true;
        }

        $state.go('pages.payment', {
            serviceId: bill.serviceId,
            url: bill.serviceId,
            fields: bill.fields || {},
            amount: bill.sum > 0 ? bill.sum : 0,
            autoCheck: pay,
            subscribe: !pay
        });
    };

    $scope.init = function () {
        $scope.getBills();
    };

    $scope.init();
}

module.exports = AccountsCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/accounts/controllers/accounts.controller.js
 ** module id = 255
 ** module chunks = 1
 **/